import { Injectable } from '@angular/core';
import { ProductClassificationType } from '../../../shared/product-classification/product-classification.models';
import { Constants, SearchOperations } from '../../../app.constants';
import { BaseService } from '../../../shared/base/base.service';
import { AttributeSelection } from '../product-catalogues/product-catalogues.models';
import { HttpRequestType } from 'src/app/core/request.service';
import CustomStore from 'devextreme/data/custom_store';
import { LS, LookupSource } from 'src/app/shared/base/base.models';

@Injectable({
  providedIn: 'root'
})
export class ProductsService extends BaseService {

  public getProductsControlOptions(active: boolean = false){    
    return this.getProductsOptions(active, '/products-control',false);
  }

public getProductsLookup() {
  return this.getLookup(LS.get('NCU'), LS.get('NC'), LookupSource.PRODUCTS, `active=true`);
}

  public getProductsOptions(active: boolean = true, urlExtension = '/products', isActiveFilter: boolean = true) {
    let url = `${Constants.contextPath}` +  urlExtension;
    let sortBy = 'name';
    let fields = ['name', 'code'];
    let activeFilter = `active${SearchOperations.EQUALITY}${active}`

    return {
      paginate: true,
      pageSize: this.pageSize,
      store: new CustomStore({
        key: 'id',
        load: (loadOptions: any) => {
          let filter = `&sortBy=${sortBy}&sortOrder=asc`;
          if (loadOptions.searchExpr && loadOptions.searchValue) {
            let fieldsFilter = '';

            if (fields != null && fields.length > 0) {
              let counter = 0;
              for (let field of fields) {
                let OR = `${SearchOperations.KEY_OR}`;
                if (counter == 0)
                  OR = '';

                if(isActiveFilter)
                  fieldsFilter = fieldsFilter + `${OR}${SearchOperations.LEFT_PARENTHESES_READABLE}${field}${SearchOperations.LIKE}${loadOptions.searchValue}${SearchOperations.SPLIT_SINGLE_OPERATION}${activeFilter}${SearchOperations.RIGHT_PARENTHESES_READABLE}`;
                else
                  fieldsFilter = fieldsFilter + `${OR}${SearchOperations.LEFT_PARENTHESES_READABLE}${field}${SearchOperations.LIKE}${loadOptions.searchValue}${SearchOperations.RIGHT_PARENTHESES_READABLE}`;
                  
                counter++;
              }
            }

            filter = `&${SearchOperations.KEY_SEARCH}=${fieldsFilter}&sortBy=${sortBy}&sortOrder=asc`;

          }

          return this.getAllAsPromise(url, loadOptions.skip ? loadOptions.skip : 0, filter, null, (response: any) => {
            let data = response;
            if (response.content != null)
              data = response.content;

            return this.modifyProductsData(data);
          });
        },
        byKey: (id: number | string | any) => {

          if (id != null && isActiveFilter)
            if (typeof id === 'string' || typeof id === 'number')
              return this.getByIdAsPromise(url, id, (response: any) => {
                return this.modifyProductsData(response);
              });
            else if (typeof id === 'object' && isActiveFilter)
              return this.getByIdAsPromise(url, id.id, (response: any) => {
                return this.modifyProductsData(response);
              });
        }
      })
    };
  }

  private modifyProductsData(response) {
    if (Array.isArray(response)) {
      for (let p of response) {
        p.label = `${p.name} ${p.code}`;
        if (p.template) {
          p.productTemplate = p.template;
          delete p.template;
        }
      }
    }
    else
      response.label = `${response.name} ${response.code}`;

    return response;
  }

  public getProductClassificationOptions(type: ProductClassificationType) {
    return this.getOptionsByMultipleFieldsFilter(this.determineProductClassificationUrl(type), 'code', ['code', 'name'], (response) => {
      if (Array.isArray(response))
        for (let p of response)
          p.name = `${p.code} ${p.name}`;
      else
        response.name = `${response.code} ${response.name}`;
      return response;
    });
  }

  public determineProductClassificationUrl(type: ProductClassificationType) {
    switch (type) {
      case ProductClassificationType.ASSORTMENT:
        return `${Constants.contextPath}/product-assortments`;
      case ProductClassificationType.BRAND:
        return `${Constants.contextPath}/product-brands`;
      case ProductClassificationType.CATEGORY:
        return `${Constants.contextPath}/product-categories`;
      case ProductClassificationType.GROUP:
        return `${Constants.contextPath}/product-groups`;
      case ProductClassificationType.MERCHANDISE_GROUP:
        return `${Constants.contextPath}/product-merchandise-groups`;
    }
  }

  public getProductsByAttribute(data: AttributeSelection, onSuccess: Function) {
    let url = `${Constants.contextPath}/products/get-by-attribute`;
    this.requestService.createRequest(HttpRequestType.Post, url, data, null, (response) => {
      onSuccess(response);
    })
  }

  public getUnitOfMeasurementOptions() {
    return this.getOptionsByMultipleFieldsFilter(`${Constants.contextPath}/units-of-measurement`, 'code', ['code', 'name'], (response) => {
      if (Array.isArray(response))
        for (let p of response)
          p.label = `${p.name} (${p.code})`;
      else
        response.label = `${response.name} (${response.code})`;
      return response;
    });
  }

  public getTaxRateOptions() {
    return this.getOptionsByMultipleFieldsFilter(`${Constants.contextPath}/tax-rates`, 'code', ['code', 'percentage'], (response) => {
      if (Array.isArray(response))
        for (let p of response)
          p.label = `${p.code} (${p.percentage})`;
      else
        response.label = `${response.code} (${response.percentage})`;
      return response;
    });
  }
  
  public getProductControlByCode(code: string, onSuccess: Function) {
    let field = "code";
    let url = `${Constants.contextPath}/products-control?search=${SearchOperations.LEFT_PARENTHESES_READABLE}${field}${SearchOperations.EQUALITY}${code}${SearchOperations.RIGHT_PARENTHESES_READABLE}`;

    return this.requestService.createRequestAsPromise(HttpRequestType.Get, url, null, null, (response) => {
      onSuccess(response);
    })
  }

  public getProductMerchandiseGroupByCode(code: string, onSuccess: Function) {
    let field = "code";
    let url = `${Constants.contextPath}/product-merchandise-groups?search=${SearchOperations.LEFT_PARENTHESES_READABLE}${field}${SearchOperations.EQUALITY}${code}${SearchOperations.RIGHT_PARENTHESES_READABLE}`;

    this.requestService.createRequest(HttpRequestType.Get, url, null, null, (response) => {
      onSuccess(response);
    })
  }
}
